import { ValidationModule } from 'ag-grid-community';

/**
 * ValidationModule do AG Grid: avisa no console de opcoes obsoletas (ex.: tooltipValueGetter, v36.2) e de modulos que
 * faltam. Fica fora do build de producao; entra em dev e no build do e2e (VITE_VITRINE=1), onde o spec
 * `ag-grid-deprecacao` falha se aparecer qualquer aviso.
 */
export const MODULOS_VALIDACAO = import.meta.env.PROD && import.meta.env.VITE_VITRINE !== '1' ? [] : [ValidationModule];
